import { render } from "./MultiUpload.vue?vue&type=template&id=f58e8204"
import script from "./MultiUpload.vue?vue&type=script&lang=ts"
export * from "./MultiUpload.vue?vue&type=script&lang=ts"
script.render = render

export default script